module.exports = __webpack_public_path__ + "7a636d5df30a8d5ad0e8cf94fe8d9aad.MP3";